import { lazy } from 'react';

export const ReferralRewardsPageLazy = lazy(() => import('./ReferralRewardsPage'));
